export const serialNumberToDate = serialNumber =>
  new Date(Math.round((serialNumber - 25569) * 3600 * 24 * 1000));

export const dateToSerialNumber = date => date / (3600 * 24 * 1000) + 25569;

export const dateToISOStringWithoutTimezone = date =>
  [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, 0),
    String(date.getDate()).padStart(2, 0),
  ].join('-');
